// extracted by mini-css-extract-plugin
export default {"container":"G1-z","heading":"H1-z","links":"I1-z","copy":"J1-z","subCopy":"K1-z","linksLeft":"L1-z","linksCenter":"M1-z","linksRight":"N1-z","link":"O1-z","onlyLink":"P1-z"};